// Canonical S3 photo URL + MLS photo folder parsing shared by PhotoCell, PropertyRecordCard, and photoCache.

export const constructPhotoUrl = (parcelId) => {
  if (!parcelId) return '';
  return `https://aventine-photos.s3.amazonaws.com/${parcelId}.jpg`;
};

export const parseMLSPhotoFolder = (folder) => {
  if (!folder) return [];
  if (Array.isArray(folder)) return folder.filter(Boolean);
  if (typeof folder === 'string') {
    const trimmed = folder.trim();
    if (!trimmed || trimmed === 'null') return [];
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
    } catch {
      // fall through to comma-separated parsing
    }
    return trimmed.split(',').map((s) => s.trim()).filter(Boolean);
  }
  console.warn('[photoUrls] parseMLSPhotoFolder: unexpected type', typeof folder, folder);
  return [];
};

// Resolves once the browser has either loaded or failed to load the image at `url`.
export const checkImageLoads = (url) => new Promise((resolve) => {
  if (!url || url === 'null' || url === 'undefined') {
    resolve(false);
    return;
  }
  const img = new Image();
  img.onload = () => resolve(true);
  img.onerror = () => resolve(false);
  img.src = url;
});
